import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "semantic-ui-react";
import { usePostRequestAction } from "../../hooks";

export const CancelExternalWorkflowButton = ({ request }) => {
  const [open, setOpen] = useState(false);

  const cancelExternalWorkflowUrl = request?.links.actions?.cancel || null;
  const { mutate: cancelExternalWorkflow, isLoading: isCanceling } =
    usePostRequestAction(cancelExternalWorkflowUrl);

  const handleCancelExternalWorkflow = async () => {
    await cancelExternalWorkflow(cancelExternalWorkflowUrl, {
      onSuccess: () => {
        location.reload();
      },
    });
    setOpen(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <Button color="red" fluid onClick={handleClick}>
        Stop QC
      </Button>

      <Modal open={open} onClose={() => setOpen(false)} size="small">
        <Modal.Header>Confirm Cancel Quality Checks</Modal.Header>
        <Modal.Content>
          <p>Are you sure you want to stop quality checks of this draft?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)} disabled={isCanceling}>
            Cancel
          </Button>
          <Button
            color="red"
            onClick={handleCancelExternalWorkflow}
            loading={isCanceling}
            disabled={isCanceling}
          >
            Confirm Stop
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

CancelExternalWorkflowButton.propTypes = {
  request: PropTypes.object.isRequired,
};
